import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const testimonials = [{
  name: 'Carlos M.',
  role: 'Dueño de Agencia de Marketing · México',
  avatar: 'https://cdn.magicpatterns.com/uploads/n3c39XbBubCMzcMkYcZqJZ/www.thispersondoesnotexist.jpg',
  stars: 5,
  quote: 'Llevaba 2 años estancado en $3,000/mes con mi agencia. Después del Protocolo RMA identifiqué que mi punto ciego era una creencia heredada de mi padre: "ganar más de cierta cantidad te convierte en mala persona". En 3 semanas cerré dos contratos que me llevaron a $8,500/mes. No cambié la estrategia — cambié al operador.',
  result: 'De $3K a $8.5K/mes en 3 semanas'
}, {
  name: 'Andrea R.',
  role: 'Trader de Forex · Colombia',
  avatar: 'https://cdn.magicpatterns.com/uploads/ajr7nhKtuXcefDhHg3N9ES/www.thispersondoesnotexist.jpg',
  stars: 5,
  quote: 'Yo era la típica trader que ganaba lunes a jueves y lo devolvía todo el viernes. Cuando hice la Matriz del Termostato descubrí que mi límite subconsciente estaba en $2,000 exactos — cada vez que me acercaba, autosaboteaba. Después del RMA, mi cuenta creció un 40% el primer mes sin cambiar ni una sola estrategia técnica.',
  result: '+40% en su cuenta el primer mes'
}, {
  name: 'Roberto S.',
  role: 'Emprendedor Digital · España',
  avatar: 'https://cdn.magicpatterns.com/uploads/smMnZ2R3zLkPu3nhUKbreH/www.thispersondoesnotexist.jpg',
  stars: 5,
  quote: 'Gasté más de $12,000 en cursos de dropshipping, IA, copywriting... y seguía en el mismo punto. Este ebook de $6.39 me dio más claridad en 48 horas que todos esos cursos juntos. El ejercicio de la Auditoría de Frecuencia me hizo ver que operaba en modo supervivencia el 90% del tiempo. Hoy facturo el triple y trabajo la mitad.',
  result: '3x facturación, 50% menos horas'
}];
export function TestimonialsSection() {
  return <section className="py-16 md:py-[80px] px-4" data-id="element-320">
      <div className="max-w-[1000px] mx-auto" data-id="element-321">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-322">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-323">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-324"></span>
            Testimonios Reales
          </div>
          <h2 className="font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-325">
            ELLOS YA ROMPIERON{' '}
            <span className="text-gold" data-id="element-326">SU HABITACIÓN DE CRISTAL</span>
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-5" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-327">
          {testimonials.map((t, index) => <motion.div key={index} variants={cardVariants} className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111] flex flex-col" data-id="element-328">
              {/* Card Header */}
              <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-329">
                <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-330"></div>
                <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-331">
                  Caso #{index + 1}
                </div>
                <div className="ml-auto flex gap-0.5" data-id="element-332">
                  {Array.from({
                length: t.stars
              }).map((_, i) => <span key={i} className="text-gold text-[10px]" data-id="element-333">
                      ★
                    </span>)}
                </div>
              </div>

              {/* Quote */}
              <div className="flex-1 px-[18px] py-[18px]" data-id="element-334">
                <div className="text-[13px] leading-[1.75] text-[#bbb] italic" data-id="element-335">
                  "{t.quote}"
                </div>
              </div>

              {/* Result Badge */}
              <div className="mx-[18px] mb-4 rounded-md border border-gold/20 bg-gold/5 px-3 py-2 text-center" data-id="element-336">
                <div className="font-heading text-[10px] font-black tracking-[1px] text-gold uppercase" data-id="element-337">
                  {t.result}
                </div>
              </div>

              {/* Author */}
              <div className="border-t border-[#1e1e1e] px-[18px] py-3 flex items-center gap-3" data-id="element-338">
                <img src={t.avatar} alt={t.name} className="h-[40px] w-[40px] rounded-full object-cover border-2 border-gold/40" data-id="element-339" />
                <div data-id="element-340">
                  <div className="font-heading text-[12px] font-black text-white" data-id="element-341">
                    {t.name}
                  </div>
                  <div className="text-[10px] text-[#666] tracking-[0.5px]" data-id="element-342">
                    {t.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}